import { generatedAPI } from './endpoints.gen';

export const advisorAPI = generatedAPI;
export const { useGetCheckQuery, useCreateCheckMutation, useDeleteCheckMutation, useUpdateCheckMutation } = advisorAPI;
